// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__0K1js","loading":"Spinner_loading__pJ8Qb"};